import DPDropDown from "framework/components/DPDropDown";
import DPSwitch from "framework/components/DPSwitch";
import DPTextBox from "framework/components/DPTextBox";
import { Text } from "framework/validators/TextValidation";
import { Button, Col, Label, Row } from "reactstrap";


const JEPostingContent = ({
    formData,
    setFormData,
    Locations,

}) => {
    return (
        <>

            <Row hidden={formData.disableLocations}>
                <Col sm={12} md={6} className="mb-4-sm">
                    <DPDropDown
                        rowClass="mb-4-sm"
                        labelText="Location"
                        textType="text"
                        optionGroup={Locations}
                        selectedGroup={formData.location}
                        onChange={(e) => {

                            setFormData({
                                ...formData,
                                location: e["value"],
                                selectedDate: e["valueDate"].slice(0, 10),
                            })
                        }
                        }
                        disabled={false}
                    />
                </Col>
            </Row>
            <Row>
                <Col sm={12} md={6} className="mb-4-sm">
                    <DPTextBox
                        rowClass="mb-4-sm"
                        labelText="Date"
                        textType="date"
                        maxLength="50"
                        value={formData.selectedDate}
                        disabled={false}
                        onChange={(e) => {
                            setFormData({
                                ...formData,
                                selectedDate: e.target.value
                            })
                        }}
                    />
                </Col>
            </Row>
            <Row>
                <Col sm={2}>
                    <Label
                        htmlFor="example-text-input"
                        className={`col-md-12 col-form-label-sm`}
                    >
                        Status
                    </Label>
                </Col>
                <Col >
                    <DPSwitch
                        rowClass={"mb-4-sm"}
                        onChange={(e) => {
                            setFormData({
                                ...formData,
                                status: e,
                            })
                        }}
                        checked={formData.status}
                        disabled={false}
                    />
                </Col>
            </Row>

            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
        </>
    );
}

export default JEPostingContent;